import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
@Component({
  selector: 'app-contact',
  standalone: true,
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  imports: [TranslateModule, ButtonModule]
})
export class ContactComponent {

  constructor() { }

  goToContact() {
    const contactUrl = 'https://mp.fnac.com/compte/vendeur/aide';
    window.open(contactUrl, '_blank', 'noopener,noreferrer');
  }

}
